import { FC } from "react";
import { StyledIframe } from './Iframe.styled'
interface Props {
  data: { height?: string; width?: string; url?: string };
}

const Iframe: FC<Props> = ({ data }) => {
  if (!data) {
    return null;
  }
  return <StyledIframe height={data.height} width={data.width} src={data.url} />;
};

export default Iframe;
